<template>
  <v-text-field
    v-model="selectedDateString"
    color="primary"
    hide-details
    label="Stichtag"
    persistent-hint
    style="width: auto; max-width: 150px"
    type="date"
    variant="outlined"
    @update:model-value="onDateChange" />
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useMetricsStore } from '@/stores/metrics.ts';
import { dateService } from '@/services/date.ts';

const $metricStore = useMetricsStore();

const selectedDateString = ref($metricStore.selectedDate || dateService.toLocalDateString(new Date()));

const onDateChange = (value: string) => {
  if (value) {
    $metricStore.updateSelectedDate(value);
  } else {
    //  If date is undefined or deleted
    const currentDay = dateService.toLocalDateString(new Date());
    selectedDateString.value = currentDay;
    $metricStore.updateSelectedDate(currentDay);
  }
};
</script>
